export const SKU_ANALYTICS_EVENTS = Object.freeze({
  MENU_CREATED: 'SKU Menu Created',
  MENU_UPDATED: 'SKU Menu Updated',
  MENU_AVAILABILITY_CHANGED: 'SKU Menu Availability Changed',
  MENU_CATEGORY_ADDED: 'SKU Menu Category Added',
  MENU_CATEGORY_REMOVED: 'SKU Menu Category Removed',
  CATEGORY_CREATED: 'SKU Category Created',
  CATEGORY_EDITED: 'SKU Category Edited',
  CATEGORY_DUPLICATED: 'SKU Category Duplicated',
  CATEGORY_AVAILABILITY_CHANGED: 'SKU Category Availability Changed',
  CATEGORY_ITEM_ADDED: 'SKU Category Item Added',
  CATEGORY_ITEM_REMOVED: 'SKU Category Item Removed',
  ITEM_CREATED: 'SKU Item Created',
  ITEM_EDITED: 'SKU Item Edited',
  ITEM_AVAILABILITY_CHANGED: 'SKU Item Availability Changed',
  VENUE_OPENED: 'SKU Venue Opened',
  VENUE_CLOSED_FOR_DAY: 'Venue Closed for day',
});
